<template>
  <div class="builder__wrapper">
    <div class="builder-back">
      <div class="builder__header" @click="navigate('/dashboard')">
        <div class="backArrowWrapper">
          <img :src="backArrow" @click="getBack" alt="back" />
        </div>
        <img
          :src="logo"
          class="logo"
          alt="logo"
          @click="navigate('/dashboard')"
        />
      </div>

      <VPreviewRenderedTemplate
        :templateId="templateId"
        :customComponent="PreviewBall"
        templateType="postcard"
        extraClass="preview-rendered-template"
      />
    </div>

    <div class="builder__container"><slot></slot></div>
  </div>
</template>

<script>
import Vue from "vue";
import VueTypes from "vue-types";

import VButton from "@/components/VButton";
import VPreviewRenderedTemplate from "@/components/VPreviewRenderedTemplate";
import logo from "@/assets/images/campaign_logo.svg";
import withNavigate from "@/mixins/withNavigate";
import { mapActions } from "vuex";
import { fetchTemplateById } from "@/api-client/template";

//assets
import backArrow from "@/assets/images/arrow-left.svg";
import pdfIconWhite from "@/assets/images/pdf-icon-white.svg";

const PreviewBall = Vue.component("PreviewBall", {
  data() {
    return {
      pdfIconWhite
    };
  },

  props: {
    onClickHandler: VueTypes.func,
    disabled: VueTypes.bool
  },

  template: `
      <div :style="styleObject" v-on="{ click: this.clickHandler }">

          <img :src="pdfIconWhite" alt="pdf"/>
          <span style="font-size: 10px; margin-top: 10px;"> Preview </span>
      </div>
  `,

  computed: {
    clickHandler() {
      return this.disabled ? () => {} : this.onClickHandler
    },

    styleObject() {
      return {
        cursor: "pointer",
        borderRadius: "50%",
        backgroundColor: this.disabled ? "rgba(26,48,76,0.7)" : "#1A304C",
        border: "none",
        color: "white",
        position: "relative",
        display: "inline-flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        paddingBottom: "5px",
        lineHeight: "0",
        width: "72px",
        height: "72px"
      };
    }
  }
});

export default Vue.component("BuilderLayout", {
  components: {
    VButton,
    VPreviewRenderedTemplate
  },

  data() {
    return { backArrow, logo, PreviewBall };
  },

  mixins: [withNavigate],

  methods: {
    getBack() {
      this.$router.go(-1);
    },

    openPreviewWindow(html, width, height) {
      const oneInch = this.measureInchLength();
      const windowWidth = oneInch * (width + 0.25);
      const windowHeight = oneInch * (height + 0.25);
      const features = `width=${windowWidth},height=${windowHeight}`;

      const wnd = window.open("", "wind", features);
      if (!wnd) {
        alert(
          "Print preview failed! Your popup blocker might be the problem. Please allow popups from inkit.io and then try again."
        );
        return;
      }
      wnd.document.write(html);
      wnd.document.body.style.overflow = "hidden";
    },

    measureInchLength() {
      const el = document.createElement("div");
      el.style.position = "absolute";
      el.style.top = "-1000px";
      el.style.width = "1in";
      document.body.appendChild(el);
      const { width } = el.getBoundingClientRect();
      document.body.removeChild(el);
      return width;
    },

    async fetchPreview(side) {
      const tempInfo = await fetchTemplateById(
        this.$router.history.current.params.id
      );
      this.fetchStaticPreview({
        template: tempInfo,
        side,
        onSuccess: html => {
          const { width, height } = this.getTemplateTypeStyle(tempInfo.type);
          this.openPreviewWindow(html, parseFloat(width), parseFloat(height));
        }
      });
    },

    getTemplateTypeStyle(type) {
      switch (type) {
        case "postcard-4x6":
          return {
            width: "6.25in",
            height: "4.25in"
          };
        case "postcard-6x9":
          return {
            width: "9.25in",
            height: "6.25in"
          };
        case "postcard-6x11":
          return {
            width: "11.25in",
            height: "6.25in"
          };
      }
    },

    getEnv() {
      return process.env.NODE_ENV;
    },

    ...mapActions("templates", ["fetchStaticPreview"])
  },
  computed: {
    templateId() {
      return this.$router.history.current.params.id;
    },

    _displayRenderButton() {
      return (
        this.getEnv() === "development" ||
        this.$router.currentRoute.name === "h-builder"
      );
    }
  }
});
</script>

<style lang="scss" scoped>
$ns: "builder";

.#{$ns}__wrapper {
  width: 100%;
  padding: 30px;
  .#{$ns}-back {
    display: flex;
    align-items: center;
  }

  .#{$ns}__header {
    display: grid;
    grid-template-columns: repeat(2, min-content);
    grid-auto-rows: 30px;
    grid-gap: 20px;
    align-items: center;

    .backArrowWrapper {
      padding-top: 5px;
    }

    img {
      cursor: pointer;
    }

    .logo {
      width: 50px;
    }
  }
}

.#{$ns}__container {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 100vh;
  padding: 30px 0;
}
</style>

<style lang="scss">
.preview-rendered-template {
  position: absolute;
  right: 65px;
  bottom: 250px;
  z-index: 9999;
}
</style>
